import l10n from "@/services/l10n";

export default [
  {
    name: "redirect",
    path: "/redirect",
    component: () =>
      import(/* webpackChunkName: "redirect" */ "@/pages/300.vue")
  },
  {
    name: "notFound",
    path: "*",
    meta: { title: l10n("PAGE_NOT_FOUND") },
    component: () =>
      import(/* webpackChunkName: "not-found" */ "@/pages/404.vue")
  }
];
